import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import lv from '@/locales/lv.json';
import en from '@/locales/en.json';
import es from '@/locales/es.json';
import lt from '@/locales/lt.json';
import et from '@/locales/et.json';

export const supportedLangs = ['lv', 'en', 'es', 'lt', 'et'];
export const defaultLang = 'lv';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      lv: { translation: lv },
      en: { translation: en },
      es: { translation: es },
      lt: { translation: lt },
      et: { translation: et }
    },
    fallbackLng: defaultLang,
    supportedLngs: supportedLangs,
    interpolation: { escapeValue: false },
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage']
    }
  });

export default i18n;
